import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { NavController } from '@ionic/angular';
import { RewardsBusiness } from 'rewards/models/rewards-business';

@Injectable({
    providedIn: 'root'
})
export class BusinessDetailsResolverService  {

    //#region Constructor

    /**
     * Class Constructor
     */
    constructor(
        public navCtrl: NavController
    )
    {

    }
    //#endregion


    //#region Methods

    /**
     * 
     * @param route 
     * @returns object containing business to show, list of other busniesses (if applicable), list of other featured businesses (if applicable)
     */
    async resolve(route: ActivatedRouteSnapshot)
    {
        let business: RewardsBusiness = route.queryParams[ 'business' ];
        let businessList = route.queryParams[ 'businessList' ];
        let featuredBusinessList = route.queryParams[ 'featuredBusinessList' ];

        return Promise.resolve({
            business: business,
            businessList: businessList,
            featuredBusinessList: featuredBusinessList
        });


    }
    //#endregion
}